import { render } from "./TitleSection.vue?vue&type=template&id=7c4f804c"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__